import * as React from "react";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { validateEmail } from "../../util/util";

const textfieldStyle = {
  width: "100%",
  "& .MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before": {
    borderBottom: 0,
  },
  "& .MuiInput-root::before": {
    borderBottom: 0,
  },
  "& .MuiInput-root::after": {
    borderBottom: 0,
  },
};

function isPlainObject(value) {
  return (
    typeof value === "object" &&
    value !== null &&
    Object.prototype.toString.call(value) === "[object Object]"
  );
}

export const MultiInputTextField = ({
  freeSolo,
  options,
  array,
  setArray,
  name,
  label,
  errors = {},
  handleClose,
  to,
  showNumberOfContactsLine,
}) => {
  const [values, setValues] = React.useState([]);

  const modifiedArray = React.useMemo(() => {
    // return array;
    return [...(array || []), ...(options?.length === 1 ? options : [])];
  }, [array, options]);

  React.useEffect(() => {
    if (options?.length === 1) {
      setArray(options);
    }
  }, []);

  const filteredOptions = React.useMemo(() => {
    // const newOptions = options?.map(el=>({...el,groupBy:...........}))
    return options?.filter((option) => {
      return !array?.some((defaultValue) => {
        const isFieldDisplayLabelMatch =
          defaultValue.fieldApiName !== undefined &&
          defaultValue.fieldApiName === option.fieldApiName;

        const isApiNameMatch =
          defaultValue.api_name !== undefined &&
          defaultValue.api_name === option.api_name;

        const isExactMatch = defaultValue === option;

        return isFieldDisplayLabelMatch || isApiNameMatch || isExactMatch;
      });
    });
  }, [array, options]);

  const checkValidEmail = (event, values, reason) => {
    let newestInput = values?.slice(-1)?.[0];
    let update =
      validateEmail(newestInput) ||
      validateEmail(newestInput?.value) ||
      newestInput?.fieldDisplayLabel ||
      newestInput?.api_name ||
      values?.length === 0;

    if (update) {
      setArray(values);
      setValues(values);
    }
    if (reason === "clear") {
      handleClose?.();
    }
  };

  // const regular = (event, values, reason) => {
  //   setArray(values);
  //   setValues(values);
  //   //-------
  //   // let newestInput = values?.slice(-1)?.[0];
  //   // let validEmail = validateEmail(newestInput);
  //   // if (validEmail) {
  //   //   setExtraArray((pre) => [...pre, newestInput]);
  //   // }
  //   //-------
  //   // const containsObject = options.some(
  //   //   (obj) => obj.api_name === newestInput?.api_name
  //   // );
  //   //-------
  //   // if (isPlainObject(newestInput)) {
  //   //   setArray(values);
  //   //   setValues(values);
  //   // }
  //   //-------
  //   if (reason === "clear") {
  //     handleClose?.();
  //   }
  // };

  return (
    <Autocomplete
      groupBy={(option) => option.groupBy}
      id="tags-filled"
      sx={{
        width: "100%",
        "& .MuiAutocomplete-inputRoot": {
          pr: "0 !important",
        },
      }}
      slotProps={{
        popper: {
          sx: {
            "& div": {
              width: "fit-content",
            },
          },
        },
        paper: {
          sx: {
            "& .MuiAutocomplete-groupLabel": {
              width: "100%",
              px: ".25rem",
              height: "1.7rem",
              position: "relative",
              top: "-.35rem",
            },
          },
        },
      }}
      size="small"
      popupIcon={""}
      limitTags={5}
      freeSolo
      multiple
      filterSelectedOptions
      defaultValue={name === "to" ? undefined : modifiedArray}
      options={filteredOptions}
      value={name === "to" ? modifiedArray : undefined}
      // value={modifiedArray}
      // autoSelect={true}
      // freeSolo={freeSolo}
      clearOnEscape
      clearOnBlur
      disableClearable={true}
      onChange={checkValidEmail}
      onBlur={(e) => {
        const newValue = e.target.value;
        if (!values.includes(newValue)) {
          checkValidEmail(e, [...values, newValue]);
        }
      }}
      getOptionLabel={(option) => {
        return option?.value || option?.fieldDisplayLabel || option?.api_name;
      }}
      renderTags={(value, getTagProps) => {
        return value?.map((option, index) => {
          return (
            <Chip
              size="small"
              variant="outlined"
              label={
                validateEmail(option)
                  ? option
                  : validateEmail(option?.value)
                  ? option?.value
                  : option?.fieldDisplayLabel || option?.api_name
              }
              {...getTagProps({ index })}
              key={(option?.fieldApiName || "") + (option?.value || "")}
            />
          );
        });
      }}
      renderInput={(params) => (
        <TextField
          name={name}
          {...params}
          // helperText={"errors"}
          // error={"!!errors.tags"}
          variant="standard"
          sx={textfieldStyle}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">{label}</InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),

            ...((showNumberOfContactsLine ? true : !to) && {
              endAdornment: (
                <>
                  <InputAdornment position="end">
                    <ClearIcon
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        // setArray([]);
                        handleClose();
                      }}
                    />
                  </InputAdornment>
                  {params.InputProps.endAdornment}
                </>
              ),
            }),
          }}
        />
      )}
    />
  );
};
